module.exports = __webpack_public_path__ + "img/1438940363.6f1a04a2.jpg";